// extracted by mini-css-extract-plugin
module.exports = {"p1bgmxi9":"p1bgmxi9","mtglwiz":"mtglwiz","soaqu9o":"soaqu9o"};